import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Icon, Modal, message} from "antd"
import ChangePartnerModal from "../sewing-partner/ChangePartnerModal"
import {listPartner, updateNewPartnerV2} from "../../../../services/api/3dApi"
import queryString from "query-string"

class BatchPartnerInfo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            partnerId: this.props.partner._id || '',
            isUpdated: false,
            error: '',
            loading: false,
            listPartners: [],
            errorUpdate: ''
        }
    }

    componentDidMount() {
        this._fetchPartners()
    }

    _onOpen = () => {
        this.setState({
            isOpen: true,
            isUpdated: false
        })
    }

    _onClose = () => {
        this.setState({
            isOpen: false,
            isUpdated: false,
            partnerId: this.props.partner._id || '',
            error: '',
            errorUpdate: ''
        })
    }

    _handleChangePartner = (value) => {
        this.setState({
            partnerId: value,
            isUpdated: true
        })
    }

    _fetchPartners = async () => {
        try {
            const payload = {type: 'print_partner'}
            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {data, success, error} = response

            if (!success) {
                this.setState({
                    error: error
                })
            }

            const {partners} = data

            this.setState({
                listPartners: partners,
                error: ''
            })
        } catch (e) {
            this.setState({
                error: e.message,
            })
        }
    }

    _onUpdateNewPartner = async () => {
        this.setState({
            loading: true,
            errorUpdate: ''
        })

        try {
            const {batchId} = this.props
            const {partnerId} = this.state

            const {'data': response} = await updateNewPartnerV2(batchId, {partnerId: partnerId})

            const {success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    errorUpdate: error
                })
            }

            this.setState({
                loading: false,
            }, () => {
                const {refreshBatchInfo} = this.props

                if (typeof refreshBatchInfo === 'function') {
                    refreshBatchInfo()
                }

                this.setState({
                    isOpen: false
                })
                message.success(`Thay đổi đối tác thành công`)
            })
        } catch (e) {
            this.setState({
                loading: false,
                errorUpdate: e.message
            })
        }
    }

    render() {
        const {partner, status} = this.props
        const {isOpen, partnerId, isUpdated, loading, error, listPartners, errorUpdate} = this.state

        return (
            <div className='BatchPartner'>
                <h6>Đối tác in/ép:
                    <strong className='ml-1'>
                        {partner.hasOwnProperty('_id') && partner.name}
                    </strong>
                    {status === 'pending' &&
                    <Icon type="edit" theme="twoTone" className='ml-1' onClick={this._onOpen}/>}
                </h6>

                <ChangePartnerModal
                    loading={loading}
                    error={error}
                    errorUpdate={errorUpdate}
                    partnerID={partnerId}
                    isOpen={isOpen}
                    listPartners={listPartners}
                    isUpdated={isUpdated}
                    onClose={this._onClose}
                    onChangePartner={this._handleChangePartner}
                    onUpdatePartner={this._onUpdateNewPartner}
                />
            </div>
        )
    }
}

BatchPartnerInfo.propTypes = {
    partner: PropTypes.object,
    status: PropTypes.string
}

export default BatchPartnerInfo
